/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import { IBaseProps } from '@home/types/common';

import './index.scss';

interface IFixedHeaderProps extends IBaseProps {}

const FixedHeader: React.FC<IFixedHeaderProps> = (props) => {
  const { style, className, children } = props;

  // 头部吸顶相关逻辑
  const [headerFixed, setHeaderFixed] = useState(false);

  useEffect(() => {
    const handleScroll = (e: any) => {
      const { target, srcElement } = e || {};
      const { classList } = target || {};
      if (classList?.contains('tea-layout__content') && classList?.contains('dbg-game-details')) {
        const { scrollTop } = srcElement || {};
        const height = target?.children[0]?.children[0]?.offsetHeight;
        if (scrollTop > height) {
          setHeaderFixed(true);
        } else if (scrollTop < height) {
          setHeaderFixed(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, true);

    return () => window.removeEventListener('scroll', handleScroll, true);
  }, []);

  return (
    <div style={style} className={classnames('dbg-fixedheader', className)}>
      <div className={classnames('dbg-game-details-fixedheader dbg-fixedheader-wrap', { visiable: headerFixed })}>
        {children}
      </div>
    </div>
  );
};

export default FixedHeader;
